export class AppJsonDecoder {
  static optBool(jsonValue: any): undefined | boolean {
    if (jsonValue === undefined || jsonValue === null) return undefined;
    return jsonValue.toString().toLowerCase().trim() === 'true';
  }

  static optDate(jsonValue: any): undefined | Date {
    if (jsonValue === undefined || jsonValue === null) return undefined;
    const date = new Date(jsonValue);
    return isNaN(date.getTime()) ? undefined : date;
  }

  static optPriceValue(jsonValue: unknown): undefined | number {
    const num =
      typeof jsonValue === 'number'
        ? jsonValue
        : typeof jsonValue === 'string' && /^\d+$/.test(jsonValue)
        ? parseInt(jsonValue, 10)
        : null;

    return num !== null ? num / 100 : undefined;
  }
}
